import { Link } from "react-router-dom";
import { HeroPage } from "../page/HeroPage";
import { CheckCircle } from "@mui/icons-material";
import { T } from "../../util/t";
import { Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const SuccessIcon = styled(CheckCircle)(({ theme }) => ({
    fontSize: "inherit",
    color: theme.palette.success.dark
}));
export const RegistrationSuccessPage = ({ icon, title, secondTitle, subtitle, organisation, secondaryAction }) =>
    <HeroPage
        icon={icon || <SuccessIcon/>}
        title={title}
        secondTitle={secondTitle}
        subtitle={subtitle}
        withFooter={false}>

        <Stack direction={{ xs: "column", md: "row" }} justifyContent="center" spacing={2} display="inline-flex">
            <Button variant="contained" component={Link} to="/user/athletes">
                <T>Athlete dashboard</T>
            </Button>
            <Button variant="outlined" component={Link} to={secondaryAction.link}>
                {secondaryAction.label}
            </Button>
        </Stack>

        <Typography marginTop={6}>
            <T email={organisation.contactEmail}>trouble_registering_contact_organiser</T>
        </Typography>
    </HeroPage>;
